import { Pipe, PipeTransform } from '@angular/core';
//example:   <p class="text-14 text-333" [outerHTML]="post.content | highlightKeyword:['biden', 'mỹ']"></p>

@Pipe({ name: 'docIdConverter' })
export class DocIdConverterPipe implements PipeTransform {
  transform(docId: string): string {
    const source_id = docId.split("_")[1];
    const post_id = docId.split("_")[0];
    if(source_id && post_id) {
        return `https://www.facebook.com/permalink.php?story_fbid=${source_id}&id=${post_id}`
    } else {
        return 'https://www.facebook.com/' + docId;
    }
  }
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_pipe/docId.pipe.ts